import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from "@common/interfaces/id";
import { IID_NETWORK_ITEMS } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDNetworkItemsState extends EntityState<IID_NETWORK_ITEMS, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_NETWORK_ITEMS , realtimeEntity: 'IID_NetworkItems'})
@InterfaceDataStore(InterfaceName.NETWORK_ITEMS)
export class IIDNetworkItemsStore extends EntityStore<IIDNetworkItemsState> {

  constructor() {
    super([]);
  }

}
